import {
  OrganizationAddress,
  organizationAddressEquals,
  toOrganizationAddress
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {PrimaryClientAddress} from "./PrimaryClientAddress";

export type PrimaryClientAddressPredicate = (
  primary: PrimaryClientAddress
) => boolean;

/**
 * The {@link matchingPrimaryAddress} is a predicate is used to determine
 * if a {@link PrimaryClientAddress} matches a given {@link OrganizationAddress}.
 *
 * @param address
 */
export const matchingPrimaryAddress =
  (address: OrganizationAddress = {}): PrimaryClientAddressPredicate =>
  (primary: PrimaryClientAddress): boolean =>
    organizationAddressEquals(address, toOrganizationAddress(primary.address));
